// extracted by mini-css-extract-plugin
export var actions = "_28-0";
export var actionsContainer = "_28-7";
export var border = "_28-1";
export var childFullHeight = "_28-f";
export var collapse = "_28-2";
export var content = "_28-a";
export var contentChild = "_28-e";
export var fullscreen = "_28-c";
export var hasLeftRadius = "_28-k";
export var headerContainer = "_28-3";
export var headerRow = "_28-5";
export var hidePadding = "_28-b";
export var navCollapsedGap = "_28-l";
export var noScrollX = "_28-m";
export var noScrollY = "_28-n";
export var noTopPadding = "_28-i";
export var optOutTopPadding = "_28-d";
export var pageMain = "_28-j";
export var pageOuter = "_28-g";
export var pagePadding = "_28-8";
export var pageScroll = "_28-9";
export var profile = "_28-o";
export var profileContainer = "_28-p";
export var profileImage = "_28-q";
export var profileMain = "_28-r";
export var profileSubtitle = "_28-t";
export var profileTitle = "_28-s";
export var showLeftPadding = "_28-h";
export var tabsPortalSlot = "_28-6";
export var tabsWrapper = "_28-4";
export var title = "_28-u";